/* Core & libraries */
import React, {useEffect, useState, useRef} from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useHotelReportsService } from '../../../../services/hotelReportsService';
import { useLocation, useNavigate } from 'react-router-dom';

/* Components */
import ComplianceGrid from './complianceGrid';
import HotelBookingReportsFilters from '../hotelBookingReoprtFilters';

/* Styles */
import styles from "./styles.js"


const ComplianceTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/policy-compliance')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      reportType: "policy-compliance",
      gridName: "complianceGrid",
      page: +initialPage,
      bookedStartDate: "",
      bookedEndDate: "",
      travelStartDate: "",
      travelEndDate: ""
    };
  });

  const { hotelReportsResponse, getHotelReportsList } = useHotelReportsService();

  const enableDownloadButton = hotelReportsResponse?.results?.dataItems.length > 0;


  useEffect(() => {
    getHotelReportsList(gridOptions);
    gridOptions.page > 1 ? navigate(`/app/reports/policy-compliance?page=${gridOptions.page}`) : navigate(`/app/reports/policy-compliance`)
  }, [gridOptions])

  const onRowClick = row => {}

  return (
    <div className={classes.complianceTab}>
      <HotelBookingReportsFilters
        response={hotelReportsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        type="REPORTS"
        enableDownloadButton={enableDownloadButton}
      />
      <ComplianceGrid
        mileageResponse={hotelReportsResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        onRowClick={onRowClick}
      />
    </div>
  )
}

export default ComplianceTab;
